<template>
  <div style="margin:25px;overflow:hidden;">
     Sales Reps

    <b-row>
      <b-col sm="4">
        <b-button size="sm"
          @click="rep_create"
          variant="primary">
          New Rep
        </b-button>
        <b-button size="sm"
          v-if="!loadFile"
          variant="primary"
          @click="export_csv">
          Export CSV
        </b-button>
        <div size="sm" v-if="!loadFile"
          style="display:inline-block;position:relative;line-height:2;">
          <input type="file" id="srepcsvin" style="width:0rem;opacity:0" v-on:change="setcsvfile(this)"></input>
          <label for="srepcsvin" class="btn btn-sm btn-primary" style="position:absolute;top:0;right:0;left:0;width:fit-content;white-space:nowrap;border-radius:5px;"> Import CSV </label>
        </div>
        <b-button
          style="margin-right:0; border-bottom-right-radius:0; border-top-right-radius:0"
          size="sm"
          v-if="loadFile"
          variant="danger"
          @click="loadFile = null;"
        >
          X
        </b-button>
        <b-button
          style="margin-left:0; border-bottom-left-radius:0; border-top-left-radius:0"
          size="sm"
          v-if="loadFile"
          variant="primary"
          @click="import_csv"
        >
          Import: {{loadFile.name}}
        </b-button>
      </b-col>
      <b-col sm="4">
        <div style="text-align:center">
          <b-button size="sm" style="margin-bottom:0;"
            v-if="pending_changes == 'unsaved'"
            @click="save_all_reps"
            variant="primary">
            Save Changes
          </b-button>
          <b-button size="sm" style="margin-bottom:0;"
            v-if="pending_changes == 'saving'"
            disabled
            variant="outline-primary">
            Saving...
          </b-button>
          <div class="rep_error_font"
            v-if="pending_errors">
            The <span class="table-danger" style="color:black">highlighted</span> representatives are incomplete and will not be shown to customers until their errors are fixed.
          </div>
        </div>
      </b-col>
      <b-col sm="4" style="text-align:right">
        <confirm-del variant="danger"
           :clear="del_clear"
           v-on:confirmed-delete="delete_all_reps">
        </confirm-del>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          striped
          hover
          show-empty
          stacked="sm"
          :items="reps"
          :fields="repFields"
          small>
          <template v-slot:cell(ctrl)="rep">
            <b-button
             variant="primary"
             class="btn_tag"             
             size="sm"
             @click="rep_edit(rep.item)"
             >
               Edit
            </b-button>
            <b-button
             variant="primary"
             class="btn_tag"
             size="sm"
             @click="rep_copy(rep.item)"
             >
               Copy
            </b-button>
            <b-button
             variant="danger"
             class="btn_tag"
             size="sm"
             @click="rep_delete(rep.item)"
             >
               Del
            </b-button>
          </template>
          <template v-slot:cell(rgn)="rep">
             {{ rep.item.rgn }}
          </template>
          <template v-slot:cell(cty)="rep">
             <div class="terhov" :desc="rep.item.cty_hov">
                {{ rep.item.cty_vis }}
             </div>
          </template>
          <template v-slot:cell(ter)="rep">
             <div class="terhov" :desc="rep.item.ter_hov">
                {{ rep.item.ter_vis }}
             </div>
          </template>
          <template v-slot:cell(name)="rep">
             <div class="rep_name_email"> {{ rep.item.name }} </div>
             <div class="rep_name_email"> {{ rep.item.em }} </div>
          </template>
          <template v-slot:cell(em)="rep">
          </template>
        </b-table>
      </b-col>
    </b-row>

    <b-modal id="bv-rep-edit" size="lg"
       :title="edit_modal_title" hide-footer>
       <b-row>
         <b-col sm="4">
           Sales Region Name
         </b-col>
         <b-col class="rep_field"
           :error="rep_edit_tmp.rgn_error"
           errmsg="Sales region is required">
           <b-input size="sm" class="rep_edit_input"
            placeholder="US Southeast"
            v-model="rep_edit_tmp.rgn">
           </b-input>
         </b-col>
       </b-row>
       <b-row>
         <b-col sm="4" class="rep_edit_label">
           Countries
           <div class="rep_edit_label_sm">(Semicolon&nbsp;Separated)</div>
         </b-col>
         <b-col class="rep_field"
           :error="rep_edit_tmp.cty_error"
           errmsg="At least one country is required">
           <textarea size="sm" class="rep_edit_input"
            placeholder="country; country; country"
            v-model="rep_edit_tmp.cty">
           </textarea>
         </b-col>
       </b-row>
       <b-row>
         <b-col sm="4" class="rep_edit_label">
           State/Province/City
           <div class="rep_edit_label_sm">(Semicolon&nbsp;Separated)</div>
         </b-col>
         <b-col>
           <textarea size="sm" class="rep_edit_input"
            placeholder="state; state; city; city"
            v-model="rep_edit_tmp.ter">
           </textarea>
         </b-col>
       </b-row>
       <b-row>
         <b-col sm="4">
           Sales Person Name
         </b-col>
         <b-col class="rep_field"
           :error="rep_edit_tmp.name_error"
           errmsg="Sales representative name is required">
           <b-input size="sm" class="rep_edit_input"
            placeholder="Pat Smith"
            v-model="rep_edit_tmp.name">
           </b-input>
         </b-col>
       </b-row>
       <b-row>
         <b-col sm="4">
           Sales Person Email
         </b-col>
         <b-col sm="5" class="rep_field">
           <b-input size="sm" class="rep_edit_input"
            :error="rep_edit_tmp.status_em != 'valid'"
            placeholder="smith@email.com"
            v-on:keyup="edit_email_key"
            v-model.trim="rep_edit_tmp.em">
           </b-input>
           <div class="rep_error_font" v-if="rep_edit_tmp.em_error">
             This email address is malformed.
           </div>
         </b-col>
         <b-col sm="3">
           <b-button size="sm"
             class="rep_modal_btn"
             variant="outline-primary"
             :disabled="rep_edit_tmp.em_error"
             @click="edit_create_room(false)"
            >
            Lookup Email
           </b-button>
         </b-col>
       </b-row>
       <b-row v-if="rep_edit_tmp.status_room == 'owner'">
         <b-col sm="4">
           Sales Person Room
         </b-col>
         <b-col sm="5">
           <b-input size="sm"
            disabled
            v-model="rep_edit_tmp.room">
           </b-input>
           <div class="rep_room_owner">
              {{ rep_edit_tmp.em }} is owner of this room
           </div>
         </b-col>
       </b-row>
       <b-row v-if="rep_edit_tmp.status_em != 'unknown' && rep_edit_tmp.status_room == 'error'">
         <b-col sm="4">
           Sales Person Room
         </b-col>
         <b-col sm="5"  class="rep_field">
           <b-input size="sm" class="rep_edit_input"
            :error="rep_edit_tmp.status_room != 'owner'"
            placeholder="patsmith-sales"
            v-on:keyup="edit_room_key"
            v-model.trim="rep_edit_tmp.room">
           </b-input>
           <div class="rep_error_font" v-if="rep_edit_tmp.room_error">
             The room name is malformed. Use only letters, numbers, and hyphens.
           </div>
         </b-col>
         <b-col sm="3">
           <b-button size="sm"
             class="rep_modal_btn"
             v-if="$parent.event.full_admin && rep_edit_tmp.status_em == 'valid'"
             :disabled="!is_valid_room(rep_edit_tmp.room)"
             variant="primary"
             @click="edit_create_room(true)"
            >
            Create room
           </b-button>
           <b-button size="sm"
            class="rep_modal_btn"
            v-if="$parent.event.full_admin && rep_edit_tmp.status_em == 'invalid'"
            :disabled="!is_valid_room(rep_edit_tmp.room)"
            variant="primary"
            @click="edit_create_user"
            >
            Create User & Room
           </b-button>
         </b-col>
       </b-row>
       <b-row v-if="rep_edit_tmp.status_em != 'unknown' && rep_edit_tmp.status_room == 'error'">
         <b-col sm="4">
         </b-col>
         <b-col sm="5">
           <div class="rep_msg_font"
              v-if="rep_edit_tmp.status_em == 'valid'"
              >
              <span> No existing room found for {{ rep_edit_tmp.em }}. </span>
              <span v-if="$parent.event.full_admin">
                Create room "{{ rep_edit_tmp.room }}" for them?
              </span>
              <span v-if="!$parent.event.full_admin">
                Only full admins can create/assign rooms.
              </span>
           </div>
           <div class="rep_msg_font"
              v-if="rep_edit_tmp.status_em == 'invalid'"
              >
             <span> No user exists for the provided email. </span>
             <span v-if="$parent.event.full_admin">
                 Either try a different email or create the user.
             </span>
             <span v-if="!$parent.event.full_admin">
                 Only full admins can create new users.
             </span>
           </div>
         </b-col>
       </b-row>
       <b-row v-if="rep_edit_tmp.status_notify == 'new_room'">
         <b-col sm="3">
         </b-col>
         <b-col sm="6"
           class="rep_email_font">
           Would you like to notify {{ rep_edit_tmp.em}}
           to set up their newly assigned room?
         </b-col>
         <b-col sm="3">
           <b-button size="sm"
             variant="primary"
             class="rep_modal_btn"
             @click="send_new_room_email">
             Send Email
           </b-button>
         </b-col>
       </b-row>
       <b-row v-if="rep_edit_tmp.status_notify == 'new_user'">
         <b-col sm="3">
         </b-col>
         <b-col sm="6"
           class="rep_email_font">
           Would you like to notify {{ rep_edit_tmp.em}}
           to reset their password and set up their newly assigned room?
         </b-col>
         <b-col sm="3">
           <b-button size="sm"
             variant="primary"
             class="rep_modal_btn"
             @click="send_new_user_email">
             Send Email
           </b-button>
         </b-col>
       </b-row>
       <b-row>
         <b-col class="rep_error_font" style="text-align:center;">
           {{ rep_edit_tmp.api_error_msg }}
         </b-col>
       </b-row>
       <div style="padding: 1vw 0px">
         <b-button-group class="">
           <b-button size="sm"
             variant="primary"
             @click="save_rep_edit">
             Save
           </b-button>
         </b-button-group>
         <b-button-group class="float-right">
           <b-button size="sm" @click="$bvModal.hide('bv-rep-edit')"
             variant="danger">
             Cancel
           </b-button>
         </b-button-group>
       </div>
    </b-modal>

  </div>
</template>

<script>
import { sync } from "vuex-pathify";
import store from "../store";
import vx_api from "../vuemix";
import utils from "../eventutils";
import ConfirmDel from "../components/ConfirmDel";
import { CSV } from "../csv.js";

export default {
  name: "update_srep",
  data() {
      return {
        reps:[],
        repFields: [
          {key: "ctrl", label: ""},
          {key: "rgn", label: "Region/Territory"},
          {key: "cty", label: "Country"},
          {key: "ter", label: "State/Province/City/etc."},
          {key: "name", label: "Sales Rep"},
          {key: "em", label: ""},
        ],
        sreps: {id:"1"},
        pending_changes: 'none',
        pending_errors: false,
        edit_modal_title: "Edit",
        rep_edit_ref: null,
        rep_edit_tmp: {},
        room_cache: {},
        saveFile: null,
        loadFile: null,
        del_clear: 0,
      };
  },
  components: {
    ConfirmDel,
  },
  created() {},
  computed: {},
  methods: {
    /***** API *****/

    /* Called when creating a new room for a user, or
     * Initializing cache from pre-existing sales rep info */
    add_room_to_cache: function(em,room) {
      let vue = this;
      if (!room) { return; }
      let e = vue.room_cache[""+em] || {};
      e.r = room;
      vue.room_cache[""+em] = e;
    },
    add_name_to_cache: function(em,name) {
      let vue = this;
      if (!name) { return; }
      let e = vue.room_cache[""+em] || {};
      e.n = name;
      vue.room_cache[""+em] = e;
    },

    create_room: function(uid, em, room, cb) {
      let vue = this;
      let url = "//"+vx.subd+".vuemix.com/api/v2/users/nick/"+room;
      vue.rep_edit_tmp.api_error_msg = "";
      if (!uid || !em || !room) { return; }
      issue_http({
        url: url,
        type: "GET",
        contentType: "application/json",
        done: function(status, rsp) {
          let j = to_json(rsp);
          if (status != 200) {
            vue.rep_edit_tmp.api_error_msg = "Could not assign room. Failed to check for room availablity.";
            cb({error:true});
            return;
          }
          if (j.status != 200) {
            if (j.message.toLowerCase() == "taken") {
              vue.rep_edit_tmp.api_error_msg = "Could not assign room. Room '"+room+"' already assigned to a different user.";
            } else {
              vue.rep_edit_tmp.api_error_msg = "Could not assign room. Room name error: "+j.message;
            }
            cb({error:true});
            return;
          }
          url = "//"+vx.subd+".vuemix.com/api/v2/users.json";
          let data = {};
          data.id = uid;
          data.nick = ""+room;
          issue_http({ url: url, type: "POST",
                   contentType: "application/json",
                   data: JSON.stringify(data),
                   done: function(status, rsp) {
                      let j = to_json(rsp);
                      if (status != 200 || j.status != 200) {
                        cb({error:true});
                      } else {
                        vue.add_room_to_cache(em,room);
                        cb();
                      }
                   }
                });
        }
      });      
      return;
    },
    create_user: function(em, name, room, cb) {
      let vue = this;
      vue.rep_edit_tmp.api_error_msg = "";
      if (!em || !room) { return; }
      let url = "//"+vx.subd+".vuemix.com/api/v2/users/nick/"+room;
      issue_http({
        url: url,
        type: "GET",
        contentType: "application/json",
        done: function(status, rsp) {
          let j = to_json(rsp);
          if (status != 200) {
            vue.rep_edit_tmp.api_error_msg = "Could not create user. Failed to check for room availablity.";
            cb({error:true});
            return;
          }
          if (j.status != 200) {
            if (j.message.toLowerCase() == "taken") {
              vue.rep_edit_tmp.api_error_msg = "Could not create user. Room '"+room+"' already assigned to a different user.";
            } else {
              vue.rep_edit_tmp.api_error_msg = "Could not create user. Room name error: "+j.message;
            }
            cb({error:true});
            return;
          }
          let names = (name || "").split(" ");
          let data = {};
          url = "https://"+vx.subd+".vuemix.com/api/v2/users.json";
          data.email = em;
          data.password = Math.random().toString(36).substring(2,15);
          data.first_name = names[0];
          names.shift();
          data.last_name = names.join(" ");
          data.nick = ""+room;
          data.isActive = true;
          data.reset = true;
          issue_http({ url: url, type: "POST",
                   contentType: "application/json",
                   data: JSON.stringify(data),
                   done: function(status, rsp) {
                      let j = to_json(rsp);
                      if (status != 200 || j.status != 200) {
                        vue.rep_edit_tmp.api_error_msg = "Failed to create new user.";
                        cb({error:true});
                      } else {
                        vue.add_room_to_cache(em,room);
                        vue.add_name_to_cache(em,name);
                        let rsp = {};
                        rsp.password = data.password;
                        rsp.token = j.data.token;
                        cb(null,rsp);
                      }
                   }
                });
        }
      });
    },
    /* Local cache check only */
    lookup_room: function(em) {
      let vue = this;
      if (!em) { return; }
      let e = vue.room_cache[""+em];
      return e;
    },
    /* Called to lookup em-to-room
     *   Create Room should call prior to trying to create room
     *   Import CSV should call this on every imported entry
     *   ? Maybe a 'validate' button to revalidate all rooms ?
     */
    lookup_room_server: function(em, cb) {
      let vue = this;
      let room;
      if (!em) { return; }
      /* Query server.
       * - If email already has a room; set and return
       */
      window.wss_send_cb(vx, "adm_room_list", {
        rtag: "srep",
        event: {
           id: vue.$parent.event.id,
        },
        filt: {
           em: em,
        }
      }, function(msg) {
        if (!msg || !msg.data ||
            msg.data.error ||
            !msg.data.r ||
            !msg.data.r.length) {
           cb(null,{});
           return;
        }
        let r;
        for (let i=0; i<msg.data.r.length; ++i) {
          r = msg.data.r[i];
          r.room = r.name.split("/")[1];
          if (r.room.indexOf(room) >= 0) {
             //console.log("Match "+r.room);
             vue.add_room_to_cache(em,r.room);
             vue.add_name_to_cache(em,r.o_dname);
             cb(null,{r:r.room,n:r.o_dname});
             return;
          }
        }
        r = msg.data.r[0];
        //console.log("First "+r.room);
        vue.add_room_to_cache(em,r.room);
        vue.add_name_to_cache(em,r.o_dname);
        cb(null,{r:r.room,n:r.o_dname});
      });
    },

    /***** LIST VIEW *****/

    rep_tmp_init: function() {  
      let vue = this;
      vue.rep_edit_ref = null;
      vue.rep_edit_tmp = {};
      ["rgn","cty","ter","name","em","room"].forEach(function(f) {
        vue.$set(vue.rep_edit_tmp, f, "");
      });
      vue.$set(vue.rep_edit_tmp, "rgn_error", false);
      vue.$set(vue.rep_edit_tmp, "cty_error", false);
      vue.$set(vue.rep_edit_tmp, "name_error", false);
      vue.$set(vue.rep_edit_tmp, "em_error", false);
      vue.$set(vue.rep_edit_tmp, "room_error", false);
      // unknown, valid, invalid
      vue.$set(vue.rep_edit_tmp, "status_em", "unknown");
      // unknown, owner, error
      vue.$set(vue.rep_edit_tmp, "status_room", "unknown");      
      vue.$set(vue.rep_edit_tmp, "status_notify", "none");
      vue.$set(vue.rep_edit_tmp, "api_error_msg", "");
    },
    rep_compute_fields(r) {
      let vue = this;
      vue.$set(r, 'cty_hov', r.cty.split(";").join(", "));
      vue.$set(r, 'cty_vis', r.cty_hov);
      if (r.cty_vis.length > 20) {
        vue.$set(r, 'cty_vis', r.cty_vis.substring(0,40) + "...");
      }

      vue.$set(r, 'ter_hov', r.ter.split(";").join(", "));
      vue.$set(r, 'ter_vis', r.ter_hov);
      if (r.ter_vis.length > 20) {
        vue.$set(r, 'ter_vis', r.ter_vis.substring(0,40) + "...");
      }
      let e = vue.lookup_room(r.em);
      if (e) {
        if (e.r) { r.room = e.r; }
        if (e.n) { r.name = e.n; }
      }
    },
    rep_check_errors: function() {
      let vue = this;
      let error = false;
      vue.reps.forEach(function(r) {
         if (!r.em || !r.valid_em) {
            r._rowVariant = "danger";
            r.errors = true;
            error = true;
         } else if (!r.room || !r.valid_room) {
            r._rowVariant = "danger";
            r.errors = true;
            error = true;
         } else {
            r._rowVariant = "";
         }
      });
      vue.pending_errors = error;
    },    
    rep_create: function() {
      let vue = this;
      vue.edit_modal_title = "New Sales Rep";
      vue.rep_tmp_init();
      vue.$bvModal.show('bv-rep-edit')
    },
    rep_edit: function(r) {
      let vue = this;
      vue.edit_modal_title = "Edit Existing Sales Rep";
      vue.rep_tmp_init();
      vue.rep_edit_ref = r;
      ["rgn","cty","ter","name","em","room"].forEach(function(f) {
        vue.rep_edit_tmp[f] = r[f];
      });

      if (r.em && r.valid_em) {
        vue.rep_edit_tmp.status_em = "valid";
      }
      if (r.room && r.valid_room) {
        vue.rep_edit_tmp.status_room = "owner";
      } else if (!r.room) {
        vue.rep_edit_tmp.room = vue.default_room(r);
      }
      vue.$bvModal.show('bv-rep-edit')
    },
    rep_copy: function(r) {
      let vue = this;
      vue.edit_modal_title = "New Sales Rep (Copied)";
      vue.rep_tmp_init();
      vue.rep_edit_ref = null;
      ["rgn","cty","ter","name","em","room"].forEach(function(f) {
        vue.rep_edit_tmp[f] = r[f];
      });

      if (r.status_em) {
        vue.rep_edit_tmp.status_em = "valid";
      }
      if (r.room) {
        vue.rep_edit_tmp.status_room = "owner";
      } else {
        vue.rep_edit_tmp.room = vue.default_room(r);
      }
      vue.$bvModal.show('bv-rep-edit')
    },
    rep_delete: function(r) {
      let vue = this;
      r._del = true;
      vue.reps.forEach(function(r, idx) {
        if (r._del) {
          vue.reps.splice(idx,1);
          vue.pending_changes = 'unsaved';
        }
      });
      vue.rep_check_errors();
    },

    /***** MODAL *****/

    save_rep_edit: function() {
      let vue = this;
      vue.rep_edit_tmp.rgn_error = false;
      vue.rep_edit_tmp.cty_error = false;
      vue.rep_edit_tmp.name_error = false;
      vue.rep_edit_tmp.em_error = false;
      if (!vue.rep_edit_tmp.rgn) {
        vue.rep_edit_tmp.rgn_error = true;
        return;
      }
      if (!vue.rep_edit_tmp.cty) {
        vue.rep_edit_tmp.cty_error = true;
        return;
      }
      if (!vue.rep_edit_tmp.name) {
        vue.rep_edit_tmp.name_error = true;
        return;
      }
      if (!vue.rep_edit_tmp.em) {
        vue.rep_edit_tmp.status_em = "unknown";
        vue.rep_edit_tmp.room = "";
      } else {
        if (!window.validate_email(vue.rep_edit_tmp.em)) {
          vue.rep_edit_tmp.em_error = true;
          return;
        }
      }
      if (!vue.rep_edit_tmp.room) {
        vue.rep_edit_tmp.status_room = "unknown";
      } else {
        if (!vue.is_valid_room(vue.rep_edit_tmp.room)) {
          vue.rep_edit_tmp.room_error = true;
          return;
        }
      }
      if (vue.rep_edit_ref) {
        /* Editing an existing rep */
        ["rgn","cty","ter","name","em","room"].forEach(function(f) {
          if (vue.rep_edit_tmp[f] != vue.rep_edit_ref[f]) {
            vue.rep_edit_ref[f] = vue.rep_edit_tmp[f];
            vue.pending_changes = 'unsaved';
          }
        });
        let valid_em = (vue.rep_edit_tmp.status_em == 'valid');
        if (vue.rep_edit_ref.valid_em != valid_em) {
           vue.rep_edit_ref.valid_em = valid_em;
           vue.pending_changes = 'unsaved';
        }
        let valid_room = (vue.rep_edit_tmp.status_room == 'owner');
        if (vue.rep_edit_ref.valid_room != valid_room) {
           vue.rep_edit_ref.valid_room = valid_room;
           vue.pending_changes = 'unsaved';
        }
        vue.rep_compute_fields(vue.rep_edit_ref);
      } else {
        /* Brand new */
        let r = {};
        vue.pending_changes = 'unsaved';
        ["rgn","cty","ter","name","em","room"].forEach(function(f) {
          r[f] = vue.rep_edit_tmp[f];
        });
        r.valid_em = (vue.rep_edit_tmp.status_em == 'valid');
        r.valid_room = (vue.rep_edit_tmp.status_room == 'owner');
        vue.rep_compute_fields(r);
        vue.reps.push(r);
      }
      vue.rep_check_errors();
      vue.$bvModal.hide('bv-rep-edit');
    },
    default_room(r) {
      if (!r || !r.name) {
          return "";
      }
      return ""+r.name.toLowerCase().replace(" ","-")+"-sales";
    },
    is_valid_room(room) {
      if (!room) { return false; }
      let re = /^[a-z0-9\-]+$/;
      return re.test(String(room));
    },
    edit_room_key: function() {
      let vue = this;
      if (vue.rep_edit_tmp.room) {
        vue.rep_edit_tmp.room = vue.rep_edit_tmp.room.toLowerCase();
      }
      vue.rep_edit_tmp.room_error = !vue.is_valid_room(vue.rep_edit_tmp.room);
    },
    edit_email_key: function() {
      let vue = this;
      let room_was_valid = (vue.rep_edit_tmp.status_room == "owner");
      //console.log("edit_email_key "+JSON.stringify(vue.rep_edit_tmp));      
      vue.rep_edit_tmp.status_em = "unknown";
      vue.rep_edit_tmp.status_room = "unknown";
      vue.rep_edit_tmp.em_error = false;
      vue.rep_edit_tmp.api_error_msg = "";

      let e = vue.lookup_room(vue.rep_edit_tmp.em);
      if (!vue.rep_edit_tmp.em) {
        return;
      }
      if (!window.validate_email(vue.rep_edit_tmp.em)) {
        vue.rep_edit_tmp.em_error = true;
        if (room_was_valid) {
          vue.rep_edit_tmp.room = "";
        }
        return;
      }

      if (e && e.n) {
        /* Do not set status_em = 'valid'. Only use local cache
           if we have everything. Otherwise force user to
           lookup again. */
        vue.rep_edit_tmp.name = e.n;
      }
      if (e && e.r) {
        vue.rep_edit_tmp.status_em = "valid";
        vue.rep_edit_tmp.status_room = "owner";
        vue.rep_edit_tmp.room = e.r;
      } else {
        if (room_was_valid) {
          vue.rep_edit_tmp.room = "";
        }
      }
    },
    edit_create_room: function(can_create) {
      let vue = this;
      let em = vue.rep_edit_tmp.em;
      if (!vue.rep_edit_tmp.room && !can_create) {
        vue.rep_edit_tmp.room = vue.default_room(vue.rep_edit_tmp);
      }
      vx_api
        .getUID(window.vx, { em:em })
        .then(res => {
           if (res.status >= 300) {
              vue.rep_edit_tmp.status_em = "invalid";
              vue.rep_edit_tmp.status_room = "error";
              return;
           }
           /* admins can get uid/nick */
           vue.rep_edit_tmp.uid = res.uid;
           vue.rep_edit_tmp.status_em = "valid";
           if (res.first_name || res.last_name) {
              vue.rep_edit_tmp.name = ""+res.first_name+" "+res.last_name;
              vue.add_name_to_cache(em,vue.rep_edit_tmp.name);
           }
           if (res.nick) {
              /* em already has a room */
              vue.rep_edit_tmp.status_room = "owner";
              vue.rep_edit_tmp.room = res.nick;
              vue.add_room_to_cache(em,res.nick);
              return;
           }
           // Found User
           vue.lookup_room_server(em,function(err,e) {
             if (e.r) {
               /* em already has a room */
               vue.rep_edit_tmp.status_room = "owner";
               vue.rep_edit_tmp.room = e.r;
             } else if (can_create && vue.$parent.event.full_admin) {
               /* Create room */
               vue.create_room(vue.rep_edit_tmp.uid, vue.rep_edit_tmp.em, vue.rep_edit_tmp.room, function(err,rsp) {
                 if (err) {
                   return;
                 }
                 vue.rep_edit_tmp.status_room = "owner";
                 vue.rep_edit_tmp.status_notify = "new_room";
               });
             } else {
               vue.rep_edit_tmp.status_room = "error";
             }
           });
       }).catch(e => {
         vue.rep_edit_tmp.status_em = "unknown";
         vue.rep_edit_tmp.status_room = "unknown";
       });
    },
    edit_create_user: function() {
      let vue = this;
      vue.create_user(vue.rep_edit_tmp.em,
                      vue.rep_edit_tmp.name,
                      vue.rep_edit_tmp.room,
                      function(err,rsp) {
           if (err) {
              return;
           }
           vue.rep_edit_tmp.status_em = "valid";
           vue.rep_edit_tmp.status_room = "owner";
           vue.rep_edit_tmp.status_notify = "new_user";
           vue.rep_edit_tmp.pwd_token = rsp.token;
      });
    },

    get_room_url: function(room) {
      let vue = this;
      let route = vue.$router.resolve({ name: 'room', params: { uid: room } });
      let url = "https://" + window.location.host + window.location.pathname + "?" + route.href;
      return url;
    },
    get_preset_url: function() {
      let vue = this;
      let route = vue.$router.resolve({ name: 'preset' });
      let url = "https://" + window.location.host + window.location.pathname + "?" + route.href;
      return url;
    },
    get_direct_preset_url: function(em,token) {
      if (!em || !token) { return; }
      let vue = this;
      let route = vue.$router.resolve({ name: 'preset' });
      let url = "https://" + window.location.host + window.location.pathname + "?" + route.href + "?preset_token="+token+"&preset_email="+encodeURIComponent(em);
      return url;
    },

    send_new_room_email: function() {
      let vue = this;
      let name = vue.rep_edit_tmp.name;
      let em = vue.rep_edit_tmp.em;
      let room = vue.rep_edit_tmp.room;
      let body,subject;
      let url = vue.get_room_url(room);

      subject = 'The '+vx.acc+' room '+room+' has been assigned to you.';
      body =  "<!DOCTYPE html><html><body>\n";
      body += '<div style="font-size:1rem;margin:1rem;">';
      body += '<div style="margin-bottom: 1rem;"> '+name+', </div>';
      body += '<div> An administrator of '+vx.acc+' has assigned the room '+room+ ' to you.</div><div> Please go to the room and set it up. </div>';
      body += '<div style="margin-left:1rem;"><a style="font-size:1.5rem;font-weight:600;" href="'+url+'"> '+room+' </a></div>\n'
      body += '<div style="margin-top: 1rem;"> Thank you! </div>';
      body += '</div>';
      body += "</body></html>";

      window.wss_send_cb(vx, "adm_event_email_attendee", {
        rtag: "srep",
        event: {
          id: vue.$parent.event.id
        },
        email: {
          em: em,
          subject: subject,
          body: body, 
        }
      }, function(msg) {
        if (msg.data.error) {
          vue.rep_edit_tmp.api_error_msg =
            "An error occurred. The email could not be sent. "+msg.data.error;
        }
        vue.rep_edit_tmp.status_notify = "none";
      });
    },

    send_new_user_email: function() {
      let vue = this;
      let name = vue.rep_edit_tmp.name;
      let em = vue.rep_edit_tmp.em;
      let room = vue.rep_edit_tmp.room;
      let token = vue.rep_edit_tmp.pwd_token;
      let url1 = vue.get_direct_preset_url(em,token) || vue.get_preset_url();
      let url2 = vue.get_room_url(room);
      let body, subject;

      subject = 'A '+vx.acc+' account has been created for you.';
      body =  "<!DOCTYPE html><html><body>\n";
      body += '<div style="font-size:1rem;margin:1rem;">';
      body += '<div style="margin-bottom: 1rem;"> '+name+', </div>';
      body += '<div> An administrator of '+vx.acc+' has created an account for you. You can sign in via Google/Apple/Facebook/Microsoft if your email '+em+' is associated with them. </div><div> Or you can reset your password using the link below to directly sign in with us. </div>';
      body += '<div style="margin-left:1rem;"><a style="font-size:1.2rem;font-weight:600;" href="'+url1+'"> Reset Password </a></div>\n'
      body += '<div> The administrator also assigned the room '+room+ ' to you.</div><div> Please go to the room and set it up. </div>';      
      body += '<div style="margin-left:1rem;"><a style="font-size:1.2rem;font-weight:600;" href="'+url2+'"> '+room+' </a></div>\n'
      body += '<div style="margin-top: 1rem;"> Thank you! </div>';
      body += '</div>';
      body += "</body></html>";

      window.wss_send_cb(vx, "adm_event_email_attendee", {
        rtag: "srep",
        event: {
          id: vue.$parent.event.id
        },
        email: {
          em: em,
          subject: subject,
          body: body, 
        }
      }, function(msg) {
        if (msg.data.error) {
          vue.rep_edit_tmp.api_error_msg =
            "An error occurred. The email could not be sent. "+msg.data.error;
        }
        vue.rep_edit_tmp.status_notify = "none";
      });
    },

    /***** Bulk Lookup *****/

    lookup_one_record: function(r,cb) {
      let vue = this;
      if (!r) { return; }

      r.valid_em = false;
      r.valid_room = false;
      if (!r.em) {
         cb();
         return;
      }

      /* Look for cached success */
      let e = vue.lookup_room(r.em);
      if (e) {
         r.valid_em = true;
         if (e.n) { r.name = e.n; }
         if (e.r) {
           r.valid_room = true;
           r.room = e.r;
         }
         cb();
         return;
      }
      /* Look for cached failure */
      if (vue.error_cache[r.em]) {
         cb();
         return;
      }

      vx_api
        .getUID(window.vx, { em: r.em })
        .then(res => {
           if (res.status >= 300) {
              vue.error_cache[r.em] = true;
              cb();
              return;
           }
           r.valid_em = true;
           if (res.first_name || res.last_name) {
              r.name = ""+res.first_name+" "+res.last_name;
           }
           vue.add_name_to_cache(r.em,r.name);

           if (res.nick) {
              r.valid_room = true;
              r.room = res.nick;
              vue.add_room_to_cache(r.em,res.nick);
              cb();
              return;
           }
           vue.lookup_room_server(r.em,function(err,e) {
              if (e.r) {
                r.valid_room = true;
                r.room = e.room;
                /* already added to cache */
              }
              cb();
           });
        }).catch(e => {
           cb();
        });
    },

    lookup_all_records: function(idx) {
       let vue = this;
       idx = idx || 0;
       if (idx == 0) {
          vue.room_cache = {};
          vue.error_cache = {};
       }
       if (!vue.reps || idx >= vue.reps.length) {
         vue.rep_check_errors();
         return;
       }
       vue.lookup_one_record(vue.reps[idx], function() {
          vue.rep_compute_fields(vue.reps[idx]);
          vue.lookup_all_records(idx+1);
       });
    },

    /***** DB *****/

    fetch_reps: function() {
      let vue = this;
      window.wss_send_cb(vx, "adm_event_get_part", {
        rtag: "srep",
        event: {
          id: vue.$parent.event.id,
          field: "sreps",
        },
      }, function(msg) {
        vue.reps = [];
        if (!msg || !msg.data || !msg.data.obj) {
          return;
        }
        let reps = msg.data.obj[0];
        if (!reps || !reps.r) { return; }
        vue.sreps.id = reps.id;
        reps.r.forEach(function(r) {
          if (r.em && r.valid_em) {
            if (r.room) { vue.add_room_to_cache(r.em, r.room); }
            if (r.name) { vue.add_name_to_cache(r.em, r.name); }
          }
          if (!r.valid_em) {
            r.valid_em = false;
          }
          if (!r.valid_room) {
            r.valid_room = false;
          }
          vue.rep_compute_fields(r);
          vue.reps.push(r);
        });
        vue.rep_check_errors();
      });
    },
    save_all_reps: function() {
      let vue = this;
      let reps = {r:[]};
      reps.id = vue.sreps.id;
      vue.pending_changes = 'saving';
      vue.reps.forEach(function(r) {
        reps.r.push({
          rgn: r.rgn,
          cty: r.cty,
          ter: r.ter,
          name: r.name,
          em: r.em,
          valid_em: r.valid_em,
          room: r.room,
          valid_room: r.valid_room,
        });
      });
      window.wss_send_cb(vx, "adm_event_set_part", {
        rtag: "srep",
        event: {
          id: vue.$parent.event.id,
          field: "sreps",
          obj: reps,
        },
      }, function(msg) {
        vue.pending_changes = 'none';
      });
    },
    delete_all_reps: function() {
      let vue = this;
      window.wss_send_cb(vx, "adm_event_del_part", {
        rtag: "srep",
        event: {
          id: vue.$parent.event.id,
          field: "sreps",
          fid: vue.sreps.id,
        },
      }, function(msg) {
         vue.del_clear++;
         vue.setup();
      });
    },

    /***** CSV *****/

    export_csv: function() {
      let vue = this;
      let csv = new CSV();
      let fieldmap = {
        "rgn": "Region",
        "cty": "Country",
        "ter": "State/Province/City",
        "name": "Name",
        "em": "Email",
        "room": "Room",
      };
      let j = {fields: [], records: []};

      Object.keys(fieldmap).forEach(function(m) {
        j.fields.push({ id: fieldmap[m] });
      });
      vue.reps.forEach(function(r) {
        let rec = {};
        Object.keys(fieldmap).forEach(function(m) {
          rec[fieldmap[m]] = r[m] || "";
        });
        j.records.push(rec);
      });

      let txt = csv.serialize(j);
      let data = new Blob([txt], { type: "text/csv" });
      if (vue.saveFile !== null) {
        window.URL.revokeObjectURL(vue.saveFile);
      }
      vue.saveFile = window.URL.createObjectURL(data);

      let link = document.createElement('a');
      document.body.appendChild(link);
      link.download = "salesreps.csv";
      link.href = vue.saveFile;
      link.target = "_blank";
      link.click();
      document.body.removeChild(link);
     },

    setcsvfile: function(ev) {
      let vue = this;
      let el = document.getElementById("srepcsvin");
      vue.loadFile = el.files[0];
    },
    import_csv: function() {
      let vue = this;
      let reader = new FileReader();
      reader.onload = function (e) {
        vue.loadFile = null;
        let contents = e.target.result;
        let csv = new CSV();
        let c = csv.parse(contents);
        if (!c || !c.r || !c.r[0]) {
          return;
        }
        let fieldmap = {};
        c.r[0].forEach(function(f,idx) {
          if (f.match(/region/i) || f.match(/rgn/i)) {
            fieldmap[idx] = "rgn";
          }
          if (f.match(/country/i) || f.match(/cty/i)) {
            fieldmap[idx] = "cty";
          }
          if (f.match(/state/i) || f.match(/province/i) || f.match(/city/i)) {
            fieldmap[idx] = "ter";
          }
          if (f.match(/^name$/i)) {
            fieldmap[idx] = "name";
          }
          if (f.match(/^email$/i)) {
            fieldmap[idx] = "em";
          }
          if (f.match(/^room$/i)) {
            fieldmap[idx] = "room";
          }
        });
        let in_reps = [];
        for (let i=1; i<c.r.length; ++i) {
          let rep = {};
          c.r[i].forEach(function(val,idx) {
             let f = fieldmap[idx];
             if (!f) { return; }
             rep[f] = val;
          });
          if (!rep.rgn || !rep.cty) {
            continue;
          }
          //console.log(JSON.stringify(rep));
          in_reps.push(rep);
        }
        vue.reps = in_reps;
        vue.lookup_all_records();
        vue.pending_changes = 'unsaved';
      };
      reader.readAsText(vue.loadFile);
    },

    /***** *****/

    setup: function () {
      let vue = this;
      if (!vue.$parent.event.id) {
        return;
      }
      vue.fetch_reps();
    },
  },
  watch: {
    "$parent.event.id": function (to, from) {
      this.setup();
    },
  },
  beforeDestroy() {
    window.wss_clr_routes(window.vx, "update_srep");
  },
  mounted() {
    let vue = this;
    vue.setup();
  },
};
</script>

<style lang="scss" scoped>
.b-form-tags {
  position:relative;
}
.tag_loc_msg {
  position:absolute;
  bottom: -0.5rem;
  color:green;
}
.tag_loc_msg[error="true"] {
  color:red;
}

.btn_tag {
 padding: 0 0.1rem;
 margin: 0 0.1rem;
 font-size: 0.8rem;
}
.terhov {
  position: relative;
  font-size: 0.9rem;
}
.terhov[desc]:hover::after {
  content: attr(desc);
  position: absolute;
  left: 0;
  bottom: 1.5rem;
  font-size: 0.7rem;
  font-weight: 600;
  font-family: sans-serif;
  /*white-space: nowrap;*/
  line-height: 1.2rem;
  /*height:auto;*/
  /*width:fit-content;*/
  color:black;
  background: #ffff90;
  padding: 0 5px;
  border-radius: 2px;
  border: none;
  z-index: 1;
}

.rep_field {
}

.rep_field[error="true"] > input {
  border: solid 1px red;
}
.rep_field[error="true"]::after {
  content: attr(errmsg);
  color: red;
  font-size: 0.7rem;
}

.rep_room_owner {
  color:gray;
  font-size: 0.7rem;
}

.rep_msg_font {
  color:black;
  font-size:0.7rem;
}

.rep_email_font {
  color:black;
  font-size:0.8rem;
  text-decoration: underline;
}

.rep_error_font {
  color:red;
  font-size:0.7rem;
}

.rep_name_email {
 font-size:0.7rem;
 white-space: nowrap;
}

.rep_modal_btn {
 font-size:0.8rem;
}

.rep_edit_label {
 line-height: 1;
}

.rep_edit_label_sm {
 font-size:0.7rem;
}

.rep_edit_input {
 width:100%;
 color: #000060;
}

.rep_edit_input[error="true"] {
  border: solid 1px red;
}

</style>
